@if (avComponent$ | async; as avComponent) {
  <p-splitter
    *ngrxLet="nav$; let nav"
    styleClass="splitter"
    stateStorage="{{ splitterConfig.storageLocation }}"
    stateKey="{{ splitterConfig.storageKey }}"
    >
    <ng-template pTemplate="tab-view">
      <div class="tab-view-split-part">
        <p-tabs [(value)]="activeIndex">
          <p-tablist>
            <p-tab [value]="0">Sequenzen</p-tab>
            <p-tab [value]="1">Untertitel/Transkript</p-tab>
            <p-tab [value]="2">
              Information
              @if (nav?.hasUsageConstraints) {
                <span
                  class="right-restriction-marker"
                  aria-label="Rechtehinweise vorhanden"
                  data-cy="right-restriction-marker"
                >(Beitragsrechte beachten!)</span>
              }
            </p-tab>
            @if (activeIndex === 1) {
              <div class="subtitle-filter-pseudo-tab-header">
                <ng-container *ngrxLet="displayOtonOnly$; let displayOtonOnly">
                  @if (!displayOtonOnly) {
                    <button data-no-search pRipple type="button" title="Filtereinstellungen"
                      class="subtitle-filter-dialog-button"
                      (click)="openSubtitleTranscriptFiltersDialog($event)">
                      <img src="assets/icons/global-filter.svg" alt="Sucheinstellungen im Standardmodus" />
                    </button>
                  }
                  @if (displayOtonOnly) {
                    <button data-no-search pRipple type="button" title="Filtereinstellungen"
                      class="subtitle-filter-dialog-button"
                      (click)="openSubtitleTranscriptFiltersDialog($event)">
                      <img src="assets/icons/global-filter-selected.svg" alt="Sucheinstellungen eingeschränkt" />
                    </button>
                  }
                </ng-container>
              </div>
            }
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel [value]="0">
              <app-sequence-content
                [readonly]="readonly"
                [contentType]="avComponent.type"
                [programId]="avComponent.program"
                [itemId]="avComponent.item"
                [keywords]="keywords"
              ></app-sequence-content>
            </p-tabpanel>
            <p-tabpanel [value]="1">
              <app-subtitle-transcript-content
                [readonly]="readonly"
                [contentType]="avComponent.type"
                [programId]="avComponent.program"
                [itemId]="avComponent.item"
                [ccId]="ccId"
                [keywords]="keywordsWithWordSequencesFilter"
              ></app-subtitle-transcript-content>
            </p-tabpanel>
            <p-tabpanel [value]="2">
              <app-information-content
                [contentType]="avComponent.type"
                [programId]="avComponent.program"
                [itemId]="avComponent.item"
                [keywords]="keywords"
              ></app-information-content>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </div>
    </ng-template>
    <ng-template pTemplate="player-view">
      @if (mediaInformation$ | async; as mediaInformation) {
        <div class="player-split-part">
          <h2 class="h-offscreen">Player</h2>
          <ng-container *ngrxLet="playerMediaCut$; let mediaCut">
            @if (mediaInformation.isAudioProgram) {
              <div class="player-container">
                <app-restriction-bar
                  aria-live="assertive"
                  [restrictions]="nav?.restrictions || []"
                ></app-restriction-bar>
                @if (mediaInformation.isAudioProgram && mediaCut) {
                  <app-envelope
                    [programId]="avComponent.program"
                    [itemId]="avComponent.item"
                    [mediaCutVtcIn]="mediaCut.vtcIn"
                    [mediaCutVtcOut]="mediaCut.vtcOut"
                    [mediaCutId]="mediaCut.mediaCutId"
                    [markerVtcIn]="(vtcIn$ | async) ?? undefined"
                    [markerVtcOut]="(vtcOut$ | async) ?? undefined"
                  ></app-envelope>
                }
                @if (mediaInformation.isAudioProgram && mediaCut) {
                  <app-sections-bar
                    class="audio-sequence-bar"
                                [sections]="
                                avComponent.type === 'item'
                                    ? (sectionInformation$ | async) ?? []
                                    : (programSectionInformation$ | async) ?? []
                            "
                    [vtcIn]="mediaCut.vtcIn"
                    [vtcOut]="mediaCut.vtcOut"
                    [displayString]="avComponent.type === 'item' ? 'S' : 'B'"
                    (sectionClicked)="jumpToVtcIn($event)"
                  ></app-sections-bar>
                }
                @if (mediaInformation.isAudioProgram && mediaCut && avComponent.type === 'program') {
                  <app-sections-bar
                    class="audio-sequence-bar"
                    [sections]="(programSequenceSectionInformation$ | async) ?? []"
                    [vtcIn]="mediaCut.vtcIn"
                    [vtcOut]="mediaCut.vtcOut"
                    [displayString]="'S'"
                    (sectionClicked)="jumpToVtcIn($event)"
                  ></app-sections-bar>
                }
                <app-player
                  #flowPlayer
                  [media]="mediaInformation"
                  [restrictions]="nav?.restrictions || []"
                  [markerVtcIn]="(vtcIn$ | async) ?? undefined"
                  [markerVtcOut]="(vtcOut$ | async) ?? undefined"
                  [previousPlayerState]="previousPlayerState$ | async"
                  (mediaCutRequested)="selectMedia($event)"
                  (audioTrackRequested)="setSelectedAudioTrack($event)"
                  (mediaCutLoaded)="onMediaCutLoaded($event)"
                  (playingStarted)="onPlayingStarted()"
                  (playState)="updatePlayState($event)"
                ></app-player>
              </div>
              <div class="in-out-main" #inOutElement>
                <app-in-out-time-code [readonly]="readonly"></app-in-out-time-code>
                <div class="in-out-group">
                  <ng-container *ngrxLet="isInOutSelectionValid$; let isInOutSelectionValid">
                    @if (!readonly) {
                      <button
                        pRipple
                        title="Mit Vermerk bestellen (v)"
                        type="button"
                        class="order-remark-button"
                        id="order-with-remark-player-button"
                        (click)="orderInOutSelectionWithRemark()"
                        [disabled]="!isInOutSelectionValid"
                        >
                        <img src="assets/icons/order-with-remark.svg" alt="" />
                      </button>
                    }
                    @if (!readonly) {
                      <button
                        pRipple
                        title="In den Warenkorb (w)"
                        class="search-button player-search-button"
                        [ngClass]="{'search-button-icon-only' : hideButtonText}"
                        type="button"
                        (click)="orderInOutSelection()"
                        [disabled]="!isInOutSelectionValid"
                        >
                        <img src="assets/icons/shopping-cart-white.svg" alt="" />@if (!hideButtonText) {
                        <span>In den Warenkorb</span>
                      }
                    </button>
                  }
                  @if (readonly) {
                    <button
                      pRipple
                      class="search-button order-search-button"
                      [ngClass]="{'search-button-icon-only' : hideButtonText}"
                      type="button"
                      (click)="goToDetails(avComponent.program, avComponent.item)"
                      >
                      <img src="assets/icons/arrow-top-right-white.svg" alt="" />
                      @if (!hideButtonText) {
                        <span>{{ avComponent.item ? "Zum Beitrag" : "Zur Sendung" }}</span>
                      }
                    </button>
                  }
                </ng-container>
              </div>
            </div>
          }
          @if (!mediaInformation.isAudioProgram) {
            <p-splitter
              styleClass="splitter-vertical"
              layout="vertical"
              stateStorage="{{ verticalSplitterConfig.storageLocation }}"
              stateKey="{{ verticalSplitterConfig.storageKey }}"
              >
              <ng-template pTemplate="player-vertical-view">
                <div class="player-vertical-split-part">
                  <div class="player-container player-vertical-container">
                    <app-restriction-bar
                      aria-live="assertive"
                      [restrictions]="nav?.restrictions || []"
                    ></app-restriction-bar>
                    <app-player
                      #flowPlayer
                      [media]="mediaInformation"
                      [restrictions]="nav?.restrictions || []"
                      [markerVtcIn]="(vtcIn$ | async) ?? undefined"
                      [markerVtcOut]="(vtcOut$ | async) ?? undefined"
                      [previousPlayerState]="previousPlayerState$ | async"
                      (mediaCutRequested)="selectMedia($event)"
                      (audioTrackRequested)="setSelectedAudioTrack($event)"
                      (mediaCutLoaded)="onMediaCutLoaded($event)"
                      (playingStarted)="onPlayingStarted()"
                      (playState)="updatePlayState($event)"
                    ></app-player>
                  </div>
                  <div class="in-out-main in-out-bottom" #inOutElement>
                    <app-in-out-time-code [readonly]="readonly"></app-in-out-time-code>
                    <div class="in-out-group">
                      <ng-container *ngrxLet="isInOutSelectionValid$; let isInOutSelectionValid">
                        @if (!readonly) {
                          <button
                            pRipple
                            title="Mit Vermerk bestellen (v)"
                            type="button"
                            class="order-remark-button"
                            id="order-with-remark-player-button"
                            (click)="orderInOutSelectionWithRemark()"
                            [disabled]="!isInOutSelectionValid"
                            >
                            <img src="assets/icons/order-with-remark.svg" alt="" />
                          </button>
                        }
                        @if (!readonly) {
                          <button
                            pRipple
                            title="In den Warenkorb (w)"
                            class="search-button player-search-button"
                            [ngClass]="{'search-button-icon-only' : hideButtonText}"
                            type="button"
                            (click)="orderInOutSelection()"
                            [disabled]="!isInOutSelectionValid"
                            >
                            <img src="assets/icons/shopping-cart-white.svg" alt="" />@if (!hideButtonText) {
                            <span>In den Warenkorb</span>
                          }
                        </button>
                      }
                      @if (readonly) {
                        <button
                          pRipple
                          class="search-button order-search-button"
                          [ngClass]="{'search-button-icon-only' : hideButtonText}"
                          type="button"
                          (click)="goToDetails(avComponent.program, avComponent.item)"
                          >
                          <img src="assets/icons/arrow-top-right-white.svg" alt="" />
                          @if (!hideButtonText) {
                            <span>{{ avComponent.item ? "Zum Beitrag" : "Zur Sendung" }}</span>
                          }
                        </button>
                      }
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="light-table-vertical-view">
              <div class="light-table">
                @if (!mediaInformation.isAudioProgram) {
                  <app-light-table-view
                    #lightTableView
                    [contentType]="avComponent.type"
                    [programId]="avComponent.program"
                    [itemId]="avComponent.item"
                    [mediaCut]="mediaCut"
                    [aspectRatio]="mediaInformation.pictureAspectRatio"
                  ></app-light-table-view>
                }
              </div>
            </ng-template>
          </p-splitter>
        }
      </ng-container>
    </div>
  }
</ng-template>
</p-splitter>
}
